export default __webpack_public_path__ + "static/media/graphic.cab26dcc.jpg";